export default "__VITE_ASSET__ti$Z155V__"